import { render } from "./ProfileTransactions.vue?vue&type=template&id=51e5398c&scoped=true"
import script from "./ProfileTransactions.vue?vue&type=script&lang=ts"
export * from "./ProfileTransactions.vue?vue&type=script&lang=ts"

import "./ProfileTransactions.vue?vue&type=style&index=0&id=51e5398c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51e5398c"

export default script